import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';
/**
 * # cn
 * @param args - array of classname arguments
 *
 * Utility function to easily create dynamic Tailwind class names without worrying about style conflicts
 *
 * @example
 * ```tsx
 * import { cn } from '@/helpers/cn.helper';
 * ...
 * const finalClass = cn('text-white', { hidden: isHidden }, className);
 * return <Component className={ finalClass }/>;
 * ```
 */
export function cn() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return twMerge(classNames(args));
}
